// extracted by mini-css-extract-plugin
module.exports = {"title":"_2sLtpP2ewsrhpKOmgrdhc3"};